import { ALL_GROUPS, TOP_N_OPTIONS } from 'constants/kpiBuilderCatalogue';
import { BuilderSection } from './BuilderSection';
import { OptionChips } from './OptionChips';
import { StepProps } from './StepProps';

const TOP_N = TOP_N_OPTIONS.map((n) => ({ id: n, label: n === ALL_GROUPS ? 'All groups' : `Top ${n}` }));

export const TopN = ({ a, patch }: StepProps) => (
  <BuilderSection title="How many groups to show" hint="Only the highest groups are kept, so “Top 10” shows the 10 with the most. Choose “All groups” to show every one, such as every course. Charts with hundreds of bars get long, so a table or a smaller number is easier to read.">
    <OptionChips options={TOP_N} selected={[a.topN]} onSelect={(id) => patch({ topN: Number(id) })} />
  </BuilderSection>
);
